import { jsx as _jsx } from "react/jsx-runtime";
function toProps(pairs) {
    return Object.fromEntries(pairs);
}
export function DynamicTag({ tag, argPairs, children }) {
    const props = toProps(argPairs);
    // JSX funciona com string para HTML/custom elements
    // Dica TS: converta para keyof JSX.IntrinsicElements para evitar erros em tags nativas
    const Tag = tag;
    return _jsx(Tag, Object.assign({}, props, { children: children }));
}
